

import { TableCell } from '@mui/material'

type props = {
    text: string,
    color?: string
}

export const TxCell = ({text, color}: props) => {
  return (
    <TableCell 
                align="right"
                sx={{
                    maxWidth: {xs: "50px", md: "300px"},
                    overflow: {xs: "hidden"},
                    textOverflow: {xs: "ellipsis"},
                    whiteSpace: {xs: "nowrap"},
                    color: color
                }}
            >
                {text}
            </TableCell>
  )
}

export default TxCell